// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"48":"53648a87","159":"e0c2dae2","295":"519e0b31"}[chunkId] + ".css";
};